import { NgModule, OnInit } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Router } from '@angular/router';
import { HttpModule } from '@angular/http';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreLogMonitorModule, useLogMonitor } from '@ngrx/store-log-monitor';

import { StoreModule, Store } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { routerReducer, RouterStoreModule } from '@ngrx/router-store';

import { TranslateModule } from '@ngx-translate/core';

// import './rxjs-operators';

import { reducer, AppState } from './store/app-store';
import { UserEffects } from './store/effects/user.effects';
import { UiEffects } from './store/effects/ui.effects';
import { LoginAction } from './store/actions/user.actions';

import { ToastModule, ToastsManager, ToastOptions } from 'ng2-toastr/ng2-toastr';

import { NavbarComponent, HeaderComponent, WidgetComponent, PageNotFoundComponent, DashboardComponent, WidgetFrameComponent, SmartWidgetComponent, SafeWidgetPipe } from './components/index';
import { AuthGuard, ThemeService } from './services/index';
import { ModuleLoaderService } from './services/module-loader.service';

import { SolarStarlinkModule } from '@solar/starlink';
import { SolarHeroBannerModule } from '@solar/hero-banner';

import { FGWService } from '@threshold/services/fgw.service';

// Temporary solution to print out package name, version, build time, etc.
if (process.env.config.isDevelopment) {
    console.log('************************************************************');
    console.log(`${process.env.config.pkgName} ${process.env.config.pkgVersion} (${process.env.config.pkgTime})`);
    console.log('************************************************************');
}

export function instrumentOptions() {
    return {
        monitor: useLogMonitor({ visible: false, position: 'right' }),
        maxAge: process.env.config.isDevelopment ? 30 : 2
    };
}

let COMPONENTS = [
    NavbarComponent,
    HeaderComponent,
    PageNotFoundComponent,
    WidgetComponent,
    DashboardComponent,
    WidgetFrameComponent,
    SmartWidgetComponent
];

export class ToastCustomOption extends ToastOptions {    
    showCloseButton = true;    
    enableHTML = true;
}

let PROVIDERS = [
    AuthGuard,
    ModuleLoaderService,
    ThemeService,
    ToastsManager,
    ToastOptions,
    { 
        provide: ToastOptions, 
        useClass: ToastCustomOption 
    },
    FGWService
];

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpModule,
        RouterModule,
        ToastModule.forRoot(),

        /**
         * StoreModule.provideStore is imported once in the root module, accepting a reducer
         * function or object map of reducer functions. If passed an object of
         * reducers, combineReducers will be run creating your application
         * meta-reducer. This returns all providers for an @ngrx/store
         * based application.
         * 
         * See: 
         */
        StoreModule.provideStore(reducer),

        /**
         * @ngrx/router-store keeps router state up-to-date in the store and uses
         * the store as the single source of truth for the router's state.
         * 
         * See: https://github.com/ngrx/router-store
         */
        RouterStoreModule.connectRouter(),

        /**
         * Store devtools instrument the store retaining past versions of state
         * and recalculating new states. This enables powerful time-travel
         * debugging.
         *
         * To use the debugger, install the Redux Devtools extension for either
         * Chrome or Firefox
         *
         * See: https://github.com/zalmoxisus/redux-devtools-extension
         */
        // process.env.config.isDevelopment ? StoreDevtoolsModule.instrumentOnlyWithExtension() : [],
        StoreDevtoolsModule.instrumentStore(instrumentOptions),
        // StoreLogMonitorModule,

        /**
         * EffectsModule.run() sets up the effects class to be initialized
         * immediately when the application starts.
         *
         * See: https://github.com/ngrx/effects/blob/master/docs/api.md#run
         */
        EffectsModule.run(UserEffects),
        EffectsModule.run(UiEffects),
        SolarStarlinkModule,
        SolarHeroBannerModule,
        TranslateModule.forChild()
    ],
    declarations: [
        NavbarComponent,
        HeaderComponent,
        PageNotFoundComponent,
        WidgetComponent,
        DashboardComponent,
        WidgetFrameComponent,
        SmartWidgetComponent,
        SafeWidgetPipe
    ],
    entryComponents: [...COMPONENTS],
    exports: [
        NavbarComponent,
        HeaderComponent,
        PageNotFoundComponent,
        WidgetComponent,
        DashboardComponent,
        WidgetFrameComponent,
        SmartWidgetComponent,
        SafeWidgetPipe
    ],
    providers: PROVIDERS
})
export class CelineAppModule {
    constructor(protected store: Store<AppState>) {
        this.store.dispatch(new LoginAction());
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/base-app.module.ts